"use client";

// imports
import Image from 'next/image';
import { useAtom } from 'jotai';

// lib files
import {
  locateAtom,
} from '@/lib/atoms/location-verification';
import { useHasMounted } from '@/lib/hooks';

// SVG's
import FamilyWatchingTV from '@/public/staticsvg/family-watching-tv.svg';

// styles
import styles from './LocateAuthorized.module.scss';

const LocateAuthorized = (props: { depStationName?: string }) => {
  const { depStationName } = props;
  const hasMounted = useHasMounted();
  const [locateState, _] = useAtom(locateAtom);

  const { verifiedStationShortCommonName: shortCommonName } = locateState;

  const stationName = depStationName || shortCommonName;

  const stationString = stationName || 'PBS';

  if(!hasMounted) return null;
  return (
    <div className={styles.locate_authorized}>
      <h1 className={styles.locate_authorized__headline}>
        Success! You can now stream <br />{stationString} Live TV on your device.
      </h1>
      <p className={styles.locate_authorized__text}>
        You now have access to multiple livestream channels from your local station. Your device should automatically update within 30 seconds.
      </p>
      <p className={styles.locate_authorized__text}>
        We may need you to verify your location to watch this livestream again in the future.
      </p>

      <Image
        alt=""
        aria-hidden="true"
        className={styles.locate_authorized__illustration}
        loading="lazy"
        src={FamilyWatchingTV}
      />
    </div>
  );
};

export default LocateAuthorized;
